<fts-ingredient-flat
  *ngIf="!choice?.showIngredientImages ||isHalfAndHalf"
  class="full-width ingredient-flat"
  [needsMaxIngredientsWarningsCheck]="needsMaxIngredientsWarningsCheck"
  [ingredient]='ingredient'
  [itemSize]='itemSize'
  [choice]='choice'
  [isInModal]="isInModal"
  [disabled]='disabled'
  [ingredientIndex]="ingredientIndex"
  [singleSelectionChoiceSelectedIngredient]='singleSelectionChoiceSelectedIngredient'
  [orderedIngredient]="orderedIngredient"
  [storeConfig]="storeConfig"
  [inItemEditorModal]="inItemEditorModal"
  [hasTags]="hasTags"
  (ingredientHalfChange)='selectHalf($event)'
  (ingredientQualifierChange)='toggleQualifier($event)'
  (ingredientSelectedChange)='toggleIngredient()'
  (tagClicked)="tagClicked.emit($event)"
  [isHalfAndHalf]="isHalfAndHalf">
</fts-ingredient-flat>

<fts-ingredient-card
  *ngIf="choice?.showIngredientImages && !isHalfAndHalf"
  class="full-width"
  [ingredient]='ingredient'
  [itemSize]='itemSize'
  [choice]='choice'
  [disabled]='disabled'
  [singleSelectionChoiceSelectedIngredient]='singleSelectionChoiceSelectedIngredient'
  [orderedIngredient]="orderedIngredient"
  [orderedChoice]="orderedChoice"
  [storeConfig]="storeConfig"
  [hasTags]="hasTagList"
  [inItemEditorModal]="inItemEditorModal"
  (ingredientHalfChange)='selectHalf($event)'
  (ingredientQualifierChange)='toggleQualifier($event)'
  (ingredientSelectedChange)='toggleIngredient()'
  (tagClicked)="tagClicked.emit($event)">
</fts-ingredient-card>
